import React, { FC } from 'react';
import { View as NativeView } from '@tarojs/components';
import classNames from 'classnames';
import { ViewProps } from '@tarojs/components/types/View';

const View: FC<ViewProps> = ({ className, ...restProps }) => <NativeView className={classNames('ink-view', className)} {...restProps} />;

export default View;
